module.exports = function() {
  return new Worker(__webpack_public_path__ + "30d3a09d46c95c6d1420.worker.js");
};